import { DataService } from "@/api/services/data.service";
import { ProductGroupDependenciesByProductType } from "@/models/product.model";
import { ProductType } from "@/api/constants/enums";
import { DropdownOptionDto } from "@/api/models/common.model";
import { DataDependencyService, ProductDependencyDto } from "@/api/product-dependencies";

const clearStorage = ({ commit }: any) => {
	commit("clearStorage");
};

const getDependencyGroups = ({ commit, getters }: any) => {
	return new Promise<void>((resolve, reject) => {
		const storageValue = getters.getProductGroupsDependencies() as ProductGroupDependenciesByProductType;
		if (storageValue) {
			const { fiber = [], voip = [], mobile = [] } = storageValue;
			const isThereAnyValue = [fiber, voip, mobile].some((item) => item.length > 0);

			if (isThereAnyValue) {
				return resolve();
			}
		}

		return DataDependencyService.fetchGroups()
			.then((data = []) => {
				const dataToSave: ProductGroupDependenciesByProductType = {
					fiber: data.filter((i) => i.feature === ProductType.FIBRE),
					voip: data.filter((i) => i.feature === ProductType.VOIP),
					mobile: data.filter((i) => i.feature === ProductType.MOBILE)
				};

				commit("saveProductGroupsDependencies", { data: dataToSave });

				resolve();
			})
			.catch(reject);
	});
};

const getDependencyNonGroups = ({ commit, getters }: any) => {
	return new Promise<void>((resolve, reject) => {
		const storageValue = getters.getProductNonGroupsDependencies() as ProductDependencyDto[];
		if (storageValue && storageValue.length) {
			return resolve();
		}

		return DataDependencyService.fetchNonGroups()
			.then((data = []) => {
				commit("saveProductNonGroupsDependencies", { data });

				resolve();
			})
			.catch(reject);
	});
};

const findDropdownData = ({ commit }: any, { key }: { key: string }) => {
	return new Promise((resolve, reject) => {
		DataService.findDropdownData({ name: key })
			.then((data) => {
				commit("saveDropdownData", { key, data });
				resolve(data);
			})
			.catch(reject);
	});
};

const loadDropdownData = ({ commit, getters }: any, { key, sortType = "default" }: { key: string; sortType?: "default" | "number" }) => {
	return new Promise((resolve, reject) => {
		if (!key) return resolve([]);

		const storeDropdownData = getters.getDropdownData({ key }) as DropdownOptionDto[];
		if (storeDropdownData.length > 0) {
			return resolve(storeDropdownData);
		}

		DataService.findDropdownData({ name: key, sortType })
			.then((data) => {
				commit("saveDropdownData", { key, data });
				resolve(data);
			})
			.catch(reject);
	});
};

const loadPermissions = ({ dispatch }: any) => {
	return new Promise((resolve) => {
		dispatch("loadUserPermissions")
			.then(() => resolve(true))
			.catch(() => resolve(false));
	});
};

export default {
	loadPermissions,
	clearStorage,
	findDropdownData,
	loadDropdownData,
	getDependencyGroups,
	getDependencyNonGroups
};
